import styled from 'styled-components';

import { minWidth } from '@calm-web/design-system';

import { useAnalytics } from '@/hooks/analytics';
import DownloadAppStore from 'icons/download-app-store.svg';
import DownloadGooglePlay from 'icons/download-google-play.svg';

const StoreButtonInner = styled.svg<{ $isSmall?: boolean; $isDynamicWidth?: boolean }>`
	cursor: pointer;
	height: 40px;
	margin-right: ${props => (props.$isSmall ? '24px' : '20px')};
	width: ${props => (props.$isDynamicWidth ? 'unset' : '134px')};

	&:last-of-type {
		margin-right: 0;
	}

	${minWidth('tablet')} {
		height: ${props => (props.$isSmall ? '40px' : '60px')};
		width: ${props => (props.$isDynamicWidth ? 'unset' : '200px')};
	}
`;

interface StoreButtonProps {
	type: 'android' | 'ios';
	eventName?: string;
	isSmall?: boolean;
	isDynamicWidth?: boolean;
}

export const StoreButton = ({ type, eventName, isSmall, isDynamicWidth }: StoreButtonProps) => {
	const { logEvent } = useAnalytics();

	function onAppleStoreClick(): void {
		logEvent({ eventName: eventName ?? 'Success : Apple Store : Clicked' });
		window.location.assign('https://itunes.apple.com/us/app/calm.com/id571800810');
	}

	function onGoogleStoreClick(): void {
		logEvent({
			eventName: eventName ?? 'Success : Google Play Store : Clicked',
		});
		window.location.assign('https://play.google.com/store/apps/details?id=com.calm.android');
	}
	return (
		<StoreButtonInner
			as={type === 'android' ? DownloadGooglePlay : DownloadAppStore}
			onClick={type === 'android' ? onGoogleStoreClick : onAppleStoreClick}
			aria-label={type === 'android' ? 'Google Play Store' : 'Apple App Store'}
			role="link"
			$isSmall={isSmall}
			$isDynamicWidth={isDynamicWidth}
		/>
	);
};
